import { META, open, runRequest, txDone } from "./store";
import { uuid } from "./uuid";
export interface SavedManual { id: string; title: string; sourceUrl: string; jobId: string; filename: string; savedAt: string; size: number; file: Blob }
const prefix = (scope: string) => `manual:${scope}:`;
export async function savedManuals(scope: string): Promise<SavedManual[]> {
  const database = await open();
  const tx = database.transaction(META, "readonly");
  const start = prefix(scope);
  const rows = await runRequest<{ key: string; value: SavedManual }[]>(tx.objectStore(META).getAll(IDBKeyRange.bound(start, start + "\uffff")));
  return rows.map(row => row.value).sort((a, b) => b.savedAt.localeCompare(a.savedAt));
}
export async function saveManual(scope: string, details: { title: string; sourceUrl: string; jobId: string }, file: File): Promise<SavedManual> {
  if (!scope || !details.title.trim()) throw new Error("Enter a manual title.");
  if (file.size > 20_000_000) throw new Error("Choose a PDF smaller than 20 MB.");
  const signature = new TextDecoder().decode(await file.slice(0, 5).arrayBuffer());
  if (signature !== "%PDF-") throw new Error("Choose a PDF file; other file types cannot be saved as manuals.");
  const database = await open();
  const tx = database.transaction(META, "readwrite");
  const store = tx.objectStore(META);
  const start = prefix(scope);
  const rows = await runRequest<{ value: SavedManual }[]>(store.getAll(IDBKeyRange.bound(start, start + "\uffff")));
  if (rows.reduce((sum, row) => sum + row.value.size, 0) + file.size > 100_000_000) {
    tx.abort();
    throw new Error("Offline manuals are limited to 100 MB per account on this device. Remove older copies first.");
  }
  const manual: SavedManual = { ...details, title: details.title.trim().slice(0, 240), id: uuid(), filename: file.name, savedAt: new Date().toISOString(), size: file.size, file: new Blob([file], { type: "application/pdf" }) };
  store.put({ key: start + manual.id, value: manual });
  await txDone(tx);
  return manual;
}
export async function removeManual(scope: string, id: string): Promise<void> {
  const database = await open();
  const tx = database.transaction(META, "readwrite");
  tx.objectStore(META).delete(prefix(scope) + id);
  await txDone(tx);
}
